export const communityAppBeta = false;
